module.exports = __webpack_public_path__ + "public/img/qrcode-qq.39ecbaa3.png";